import { render, staticRenderFns } from "./AliveLogo.vue?vue&type=template&id=7ed83aab&scoped=true&"
import script from "./AliveLogo.vue?vue&type=script&lang=js&"
export * from "./AliveLogo.vue?vue&type=script&lang=js&"
import style0 from "./AliveLogo.vue?vue&type=style&index=0&id=7ed83aab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed83aab",
  null
  
)

export default component.exports